<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="18"
    viewBox="0 0 12 18"
    fill="none"
  >
    <path
      d="M10.9748 11.0203C10.9416 10.6044 10.8579 10.1941 10.7255 9.79842C9.72799 6.20758 6.01247 1.51953 6.01247 1.51953C6.01247 1.51953 2.29694 6.20758 1.27455 9.79842C1.14211 10.1941 1.05837 10.6044 1.02518 11.0203C1.02518 11.145 1.00025 11.2697 1.00025 11.3944C0.993669 12.0579 1.11828 12.7163 1.36691 13.3315C1.61555 13.9468 1.98331 14.5069 2.44906 14.9796C2.91482 15.4523 3.46939 15.8283 4.08092 16.0861C4.69244 16.3438 5.34886 16.4781 6.01247 16.4814C6.67397 16.4749 7.3277 16.3381 7.93635 16.0789C8.54499 15.8197 9.09662 15.4432 9.55974 14.9708C10.0229 14.4985 10.3884 13.9395 10.6355 13.3258C10.8826 12.7122 11.0063 12.0558 10.9998 11.3944C10.9998 11.2697 10.9998 11.145 10.9748 11.0203Z"
      fill="white"
      stroke="#222222"
      stroke-opacity="0.8"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "IconHumi",
};
</script>

<style></style>
